import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _batchCreateCategoryRequest = {};
var _batchCreateCategoryResponse = {};
var _batchUpdateCategoryRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _batchUpdateCategoryResponse = {};
var _createCategoryRequest = {};
var _createCategoryResponse = {};
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _listCategoryRequest = {};
var _listCategoryResponse = {};
var _updateCategoryRequest = {};
var _updateCategoryResponse = {};
function resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/services-server/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/services-server/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/bookings/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
            {
                srcPath: '/_api/services-server/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/services-server/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/categories-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-server/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/services-server/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/_api/services-server/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/services-server/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Lists all categories. */
export function list(payload) {
    var _a = serializer(_listCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoryResponse, {}).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.List',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/** Creates a new category. */
export function create(payload) {
    var _a = serializer(_createCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.Create',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/** Creates multiple new categories. */
export function batchCreate(payload) {
    var _a = serializer(_batchCreateCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchCreateCategoryResponse, {}).fromJSON;
    function __batchCreate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.BatchCreate',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/batch/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchCreate.fromReq = fromReq;
    __batchCreate.__isAmbassador = true;
    return __batchCreate;
}
/** Updates an existing category. */
export function update(payload) {
    var _a = serializer(_updateCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'PUT',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.Update',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/**
 * Deletes a category.
 * When deleting a category, you have the option to delete all the associated services within this category using the `deleteServices` field in the request.
 */
export function _delete(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'DELETE',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService._Delete',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/** Updates multiple categories. */
export function batchUpdate(payload) {
    var _a = serializer(_batchUpdateCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchUpdateCategoryResponse, {}).fromJSON;
    function __batchUpdate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.category',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.BatchUpdate',
            url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchUpdate.fromReq = fromReq;
    __batchUpdate.__isAmbassador = true;
    return __batchUpdate;
}
//# sourceMappingURL=http.impl.js.map